import { createRouter, createWebHistory } from 'vue-router';
import MagicLink from '../components/public/MagicLink.vue';
import AdminRoot from '@/components/admin/AdminRoot.vue';
import AdminDeviceList from '@/components/admin/AdminDeviceList.vue';
import AdminDeviceDetail from '@/components/admin/AdminDeviceDetail.vue';
import AdminDeviceLogsList from '@/components/admin/AdminDeviceLogsList.vue';
import AdminDeviceLogDetail from '@/components/admin/AdminDeviceLogDetail.vue';
import AdminDeviceConvs from '@/components/admin/AdminDeviceConvs.vue';

const routes = [
  {
    path: '/',
    redirect: '/parent',
  },
  {
    path: '/authenticate',
    name: 'MagicLink',
    component: MagicLink,  // Cette route gère l'authentification via le token
    meta: { scrollToTop: true, titleKey: 'pageTitles.authenticate' },
  },
  {
    path: '/delete-account',
    component: () => import('@/components/public/DeleteAccountPage.vue'),
    meta: { scrollToTop: true, titleKey: 'pageTitles.deleteAccount' },
  },
  {
    path: '/privacy-policy',
    beforeEnter: () => {
      window.location.replace('https://www.clevinoo.com/pages/privacy-policy');
      return false;
    },
  },
  {
    path: '/parent',
    component: () => import('@/components/parent/ParentDetail.vue'),
    meta: { requiresAuth: true, titleKey: 'pageTitles.parent' },  // Cette route nécessite un token valide
    children: [
      {
        path: ':childId',
        component: () => import('@/components/parent/ParentChildDetail.vue'), children: [
          { path: '', redirect: to => `/parent/${to.params.childId}/settings` },
          { path: 'settings', component: () => import('@/components/parent/ParentChildSettings.vue'), meta: { titleKey: 'pageTitles.parentChildSettings', childTitleKey: 'pageTitles.parentChildSettingsNamed' } },
          {
            path: 'conversations', component: () => import('@/components/parent/ParentChildConversationList.vue'), meta: { titleKey: 'pageTitles.parentConversations', childTitleKey: 'pageTitles.parentConversationsNamed' }, children: [
              { path: ':convId', component: () => import('@/components/parent/ParentChildConversationDetail.vue'), meta: { titleKey: 'pageTitles.parentConversationDetail', childTitleKey: 'pageTitles.parentConversationDetailNamed' } }
            ]
          },
          { path: 'devices', component: () => import('@/components/parent/ParentChildDevices.vue'), meta: { titleKey: 'pageTitles.parentChildDevices', childTitleKey: 'pageTitles.parentChildDevicesNamed' } }
        ]
      }]
  },
  {
    path: '/admin',
    component: AdminRoot,
    meta: { requiresAdmin: true, titleKey: 'pageTitles.admin' },
    children: [
      {
        path: 'devices',
        component: AdminDeviceList,
        meta: { titleKey: 'pageTitles.adminDevices' },
        children: [
          {
            path: ':deviceId',
            component: AdminDeviceDetail,
            meta: { titleKey: 'pageTitles.adminDeviceDetail' },
            children: [
              {
                path: 'logs', component: AdminDeviceLogsList, meta: { titleKey: 'pageTitles.adminDeviceLogs' }, children: [
                  { path: ':logFileName', component: AdminDeviceLogDetail, meta: { titleKey: 'pageTitles.adminDeviceLogDetail' } }
                ]
              },
              { path: 'conv', component: AdminDeviceConvs, meta: { titleKey: 'pageTitles.adminDeviceConversations' } }
            ]

          }
        ]
      },
      { path: 'usage', component: () => import('@/components/admin/AdminDeviceUsage.vue'), meta: { titleKey: 'pageTitles.adminUsage' } }
      , { path: 'telemetry', component: () => import('@/components/admin/AdminTelemetry.vue'), meta: { titleKey: 'pageTitles.adminTelemetry' } }
    ]
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }

    if (to.matched.some(record => record.meta.scrollToTop)) {
      return { top: 0 };
    }

    return false;
  },
});
function parseJwt(token) {
  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    return JSON.parse(atob(base64));
  } catch (error) {
    console.error("Unable to decode token", error);
    return null;
  }
}
function isTokenExpired(token) {
  try {
    const decodedToken = parseJwt(token);
    const currentTime = Math.floor(Date.now() / 1000); // Obtenir l'heure actuelle en secondes
    if (!decodedToken.parentId)
      return true;
    console.info('token date: ' + decodedToken.exp)
    console.info('current date: ' + currentTime)
    return decodedToken.exp < currentTime;
  } catch (error) {
    console.error("Token invalid or unable to decode", error);
    return true; // Considérer le token comme expiré s'il ne peut pas être décodé
  }
}
function isAdmin(token) {
  try {
    const decodedToken = parseJwt(token);
    console.info('token date: ' + decodedToken.exp)
    console.info('token role: ' + decodedToken.role)
    return decodedToken.role == 'Admin';
  } catch (error) {
    console.error("Token invalid or unable to decode", error);
    return true; // Considérer le token comme expiré s'il ne peut pas être décodé
  }
}

// Middleware pour vérifier l'authentification
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    console.info('route require authentification');
    const token = localStorage.getItem('auth_token');
    if (token) {
      console.info('authentification token exists');
      if (isTokenExpired(token)) {
        console.info('authentification token obsolete');
        localStorage.removeItem('auth_token');
        // Rediriger vers la page magiclink avec le callbackurl
        next({ name: 'MagicLink', query: { callbackurl: to.fullPath } });
      } else {
        console.info('authentification token permitted');
        next();
      }
    } else {
      console.info('no authentification token');
      // Rediriger vers la page magiclink avec le callbackurl
      next({ name: 'MagicLink', query: { callbackurl: to.fullPath } });
    }
  } else if (to.matched.some(record => record.meta.requiresAdmin)) {
    console.info('route require authentification');
    const token = localStorage.getItem('auth_token');
    if (token) {
      console.info('authentification token exists');
      if (isTokenExpired(token)) {
        console.info('authentification token obsolete');
        localStorage.removeItem('auth_token');
        // Rediriger vers la page magiclink avec le callbackurl
        next({ name: 'MagicLink', query: { callbackurl: to.fullPath } });
      } else if (isAdmin(token)) {
        console.info('admin authentification token permitted');
        next();
      } else {
        console.info('user is not admin');
        localStorage.removeItem('auth_token');
        // Rediriger vers la page magiclink avec le callbackurl
        next({ name: 'MagicLink', query: { callbackurl: to.fullPath } });
      }
    } else {
      console.info('no authentification token');
      // Rediriger vers la page magiclink avec le callbackurl
      next({ name: 'MagicLink', query: { callbackurl: to.fullPath } });
    }
  } else {
    console.info('route is public');
    next();
  }
});

export default router;

